import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  static targets = ["newCheckbox", "updateCheckbox", "rowCheckbox"]

  connect() {
    // Initialize Bootstrap tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })

    // Initialize checkbox states
    this.updateCheckboxStates()
  }

  toggleNewRows(event) {
    const isChecked = event.target.checked
    const table = event.target.closest('table')
    const checkboxes = Array.from(table.querySelectorAll('input[type="checkbox"]')).filter(cb => cb.id !== 'check-all-new')
    checkboxes.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateCheckboxStates()
  }

  toggleUpdateRows(event) {
    const isChecked = event.target.checked
    const table = event.target.closest('table')
    const checkboxes = Array.from(table.querySelectorAll('input[type="checkbox"]')).filter(cb => cb.id !== 'check-all-updates')
    checkboxes.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateCheckboxStates()
  }

  toggleRow(event) {
    const checkbox = event.target
    const table = checkbox.closest('table')
    const masterCheckbox = table.querySelector('#check-all-new, #check-all-updates')

    if (masterCheckbox) {
      const checkboxes = Array.from(table.querySelectorAll('input[type="checkbox"]')).filter(cb => cb.id !== masterCheckbox.id)
      const checkedCount = checkboxes.filter(cb => cb.checked).length
      const totalCount = checkboxes.length

      if (checkedCount === 0) {
        masterCheckbox.checked = false
        masterCheckbox.indeterminate = false
      } else if (checkedCount === totalCount) {
        masterCheckbox.checked = true
        masterCheckbox.indeterminate = false
      } else {
        masterCheckbox.checked = false
        masterCheckbox.indeterminate = true
      }
    }
  }

  updateCheckboxStates() {
    // Handle new rows table
    const newTable = document.querySelector('#check-all-new')?.closest('table')
    if (newTable) {
      const newCheckboxes = Array.from(newTable.querySelectorAll('input[type="checkbox"]')).filter(cb => cb.id !== 'check-all-new')
      const newCheckbox = this.newCheckboxTarget
      this.updateMasterCheckbox(newCheckbox, newCheckboxes)
    }

    // Handle update rows table
    const updateTable = document.querySelector('#check-all-updates')?.closest('table')
    if (updateTable) {
      const updateCheckboxes = Array.from(updateTable.querySelectorAll('input[type="checkbox"]')).filter(cb => cb.id !== 'check-all-updates')
      const updateCheckbox = this.updateCheckboxTarget
      this.updateMasterCheckbox(updateCheckbox, updateCheckboxes)
    }
  }

  updateMasterCheckbox(masterCheckbox, checkboxes) {
    if (!masterCheckbox || !checkboxes.length) return

    const checkedCount = checkboxes.filter(cb => cb.checked).length
    const totalCount = checkboxes.length

    if (checkedCount === 0) {
      masterCheckbox.checked = false
      masterCheckbox.indeterminate = false
    } else if (checkedCount === totalCount) {
      masterCheckbox.checked = true
      masterCheckbox.indeterminate = false
    } else {
      masterCheckbox.checked = false
      masterCheckbox.indeterminate = true
    }
  }
}
